import { ParentTaskModel } from "@/components/parent-task-plate";
import { TreeItemType } from "@/components/sidebar/enums";
import { GroupModel, NamespaceModel, QueueTasksModel } from "@/components/sidebar/models";

/**
 * * Модель очереди в списке
 */
export class QueueCardtemModel {
  /**ID очереди */
  Id!: string;
  /**Название очереди */
  Name!: string;
  /**Кол-во задач */
  TasksCount!: number;
  /**ID родительской группы */
  ParentGroupId?: number;
  /**Тип в дереве */
  readonly Type: TreeItemType = TreeItemType.Queue;
  IsQueueTasksModel: boolean = false;
  /**Родительская задача */
  ParentTask?: ParentTaskModel
  /**Является ли объект рабочей областью */
  isNamespace = (): this is NamespaceModel => false;
  /**Является ли объект группой */
  isGroup = (): this is GroupModel => false;
  /**Является ли объект очередью */
  isQueue = (): this is QueueTasksModel => true;

  /**Выбран в сайдбаре */
  isSelectedInSidebar: boolean = false;

  constructor(obj?: Partial<QueueCardtemModel>) {
    Object.assign(this, obj);
  }
}
